import React from 'react';

import { CMSLink, CMSLinkType } from '@/components/Link';

export const Link: React.FC<{ link: CMSLinkType; className?: string }> = ({
  link,
  className,
}) => {
  return <CMSLink className={className} {...link} />;
};
